var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { message } from 'antd';
import { useStore } from '../../store/rootStore';
import i18n from '../../i18n';
/**
 * Route component that enforces permission and condition requirements
 * Redirects users without required permissions or failing conditions to a specified path
 */
const ProtectedRoute = observer((_a) => {
    var { requiredPermissions, condition, redirectTo = '/', showWarning = true, children, component, render } = _a, routeProps = __rest(_a, ["requiredPermissions", "condition", "redirectTo", "showWarning", "children", "component", "render"]);
    const { agentsStore } = useStore();
    const history = useHistory();
    const hasPermission = !requiredPermissions || (agentsStore.rolesFetched && requiredPermissions.some(permission => agentsStore.hasPermissions([permission])));
    const meetsCondition = !condition || condition();
    const isAllowed = hasPermission && meetsCondition;
    const isReady = !requiredPermissions || agentsStore.rolesFetched;
    useEffect(() => {
        if (isReady && !isAllowed) {
            if (showWarning) {
                message.warning(i18n.t('insufficientPermissions'));
            }
            history.replace(redirectTo);
        }
    }, [isAllowed, isReady, history, redirectTo, showWarning]);
    if (!isReady) {
        return null;
    }
    if (!isAllowed) {
        return null;
    }
    return (React.createElement(Route, Object.assign({}, routeProps, { component: component, render: render }), children));
});
export default ProtectedRoute;
